import { FC } from "react";
import {IResolveFATServiceOrderFormSchema, TestHeaderMap} from "./schema";
import lodash from "lodash";
import {classNames} from "utils";

const TestSummary: FC<{ data: IResolveFATServiceOrderFormSchema["test"], values: IResolveFATServiceOrderFormSchema, }> = ({ data, values }) => (
  <div className="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-md p-3 space-y-6 divide-y divide-gray-200">
    <div>
      <span className="text-xs font-light">Test Information</span>
      <div className="grid grid-cols-3 gap-6 mt-2">
        <div className="col-span-3">
          <div className="mt-1 w-full ">
            <table className="min-w-full divide-y divide-gray-300 border border-gray-300 rounded-md">
              <thead className="bg-gray-50">
              <tr className="divide-x divide-gray-200">
                <th
                  scope="col"
                  className="whitespace-nowrap px-2 py-2 text-left text-sm font-semibold text-gray-900"
                >
                  Test
                </th>
                <th
                  scope="col"
                  className="whitespace-nowrap px-2 py-2 text-sm font-semibold text-gray-900 w-[300px]"
                >
                  Reference Document
                </th>
                <th
                  scope="col"
                  className="whitespace-nowrap px-2 py-2 text-sm font-semibold text-gray-900 w-[100px]"
                >
                  Status
                </th>
              </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
              {lodash.map(
                Object.keys(TestHeaderMap),
                (header, idx) => {
                  const id = `${header}`;

                  return (
                    <tr key={idx} className="divide-x divide-gray-200">
                      <td className="p-0">
                        <input
                          key={idx}
                          type={"text"}
                          id={`index`}
                          name={`index`}
                          value={`${TestHeaderMap[header as keyof  typeof TestHeaderMap]}`}
                          placeholder={"eg. 1"}
                          disabled
                          className={classNames(
                            "focus:ring-primary-500 focus:border-primary-500 border-gray-200 bg-gray-50",
                            "block w-full text-ellipsis sm:text-sm placeholder:font-light placeholder:text-xs h-[38px] border-0 focus:border"
                          )}
                        />
                      </td>
                      <td className="p-0 relative">
                        <input
                          key={idx}
                          type={"text"}
                          id={`${id}.reference`}
                          name={`${id}.reference`}
                          value={lodash.get(
                            data,
                            `${id}.reference`,
                            ""
                          )}
                          disabled
                          onChange={() => {}}
                          onBlur={() => {}}
                          className={classNames(
                            "outline-none block w-[300px] text-ellipsis sm:text-sm placeholder:font-light placeholder:text-gray-700 placeholder:text-xs h-[38px]",
                            "focus:ring-primary-500 focus:border-primary-500 border-gray-200 border-0 focus:border",
                          )}
                        />
                      </td>
                      <td className="p-0 whitespace-nowrap w-[100px] text-sm text-gray-500 dark:text-gray-400 text-left h-[38px]">
                        <input
                          key={idx}
                          type={"text"}
                          id={`${id}.status`}
                          name={`${id}.status`}
                          value={lodash.get(
                            data,
                            `${id}.status`,
                            ""
                          )}
                          onChange={() => {}}
                          onBlur={() => {}}
                          disabled
                          className={classNames(
                            "outline-none block w-[100px] font-medium sm:text-sm placeholder:font-light placeholder:text-gray-700 placeholder:text-xs h-[38px]",
                            "focus:ring-primary-500 focus:border-primary-500 border-gray-200 border-0 focus:border",
                            lodash.get(data,`${id}.status`) === 'Pass'
                              ? "text-green-500"
                              : "text-red-500"
                          )}
                        />
                      </td>
                    </tr>
                  );
                }
              )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default TestSummary;